<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title">
                                    <h4 class="mb-4">Nova Conta - UzePay</h4>
                                    <p>Preencha o formulário, para criar a sua conta UzePay.</p>
                                </div>
                                <div class="clearfix">
                                    <div class="vx-row">
                                        <div class="vx-col w-full">
                                            <vs-input
                                                v-validate="'required|min:3'"
                                                data-vv-validate-on="blur"
                                                label-placeholder="Nome Completo"
                                                name="name"
                                                placeholder="Nome Completo"
                                                v-model="name"
                                                class="w-full"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                                        </div>

                                        <div class="vx-col w-full">
                                            <vs-input
                                                v-validate="'required|alpha_dash|min:3'"
                                                data-vv-validate-on="blur"
                                                label-placeholder="Login"
                                                name="username"
                                                placeholder="Login"
                                                v-model="username"
                                                class="w-full"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('username') }}</span>
                                        </div>
												
                                        <div class="vx-col w-full">
                                            <vs-input
                                                v-validate="'required|email'"
                                                data-vv-validate-on="blur"
                                                name="email"
                                                type="email"
                                                label-placeholder="Email"
                                                placeholder="Email"
                                                v-model="email"
                                                class="w-full mt-6"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                        </div>

                                        <div class="vx-col w-full">
                                            <vs-input
                                                ref="password"
                                                type="password"
                                                data-vv-validate-on="blur"
                                                v-validate="'required|min:6|max:10'"
                                                name="password"
                                                label-placeholder="Password"
                                                placeholder="Password"
                                                v-model="password"
                                                class="w-full mt-6"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                                        </div>

                                        <div class="vx-col w-full">
                                            <vs-input
												v-mask="['###.###.###-##', '##.###.###/####-##']"
                                                data-vv-validate-on="blur"
                                                v-validate="'required|min:14|max:18'"
                                                name="cpfcnpj"
                                                label-placeholder="CPF/CNPJ" 
                                                placeholder="CPF/CNPJ"
                                                v-model="cpfcnpj"
                                                class="w-full mt-6"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('cpfcnpj') }}</span>
                                        </div>
                                        <div class="vx-col w-full">
                                            <vs-input
												v-mask="'##/##/####'"
                                                data-vv-validate-on="blur"
                                                v-validate="'required|min:10'"
                                                name="datanascimento"
                                                label-placeholder="Data de Nascimento" 
                                                placeholder="Data de Nascimento"
                                                v-model="datanascimento"
                                                class="w-full mt-6"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('datanascimento') }}</span>
                                        </div>
                                        <div class="vx-col w-full">
                                            <vs-input
												v-mask="'#####-###'"
                                                data-vv-validate-on="blur"
                                                v-validate="'required|min:9'"
                                                name="cep"
                                                label-placeholder="CEP" 
                                                placeholder="CEP"
                                                v-model="cep"
                                                class="w-full mt-6"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('cep') }}</span>
                                        </div>
										<div class="vx-col w-full">
                                            <vs-input
												v-mask="'######'"
                                                data-vv-validate-on="blur"
                                                v-validate="'required|min:6'"
                                                name="pin"
                                                label-placeholder="PIN" 
                                                placeholder="PIN"
                                                v-model="pin"
                                                class="w-full mt-6"
                                                @keyup.enter="registerUser" />
                                            <span class="text-danger text-sm">{{ errors.first('pin') }}</span>
                                        </div>
                                    </div>
                                    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">Eu aceito os termos e condições.</vs-checkbox>
                                    <vs-button  type="border" to="/pages/login" class="mt-6">Login</vs-button>
                                    <vs-button class="float-right mt-6" @click="registerUser" :disabled="!validateForm">Cadastrar</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import {mask} from 'vue-the-mask'
export default {

	directives: {
		mask
	},
    data() {
        return {
            name: '',
            username: '',
            email: '',
            password: '',
			pin: '',
			datanascimento: '',
            cep: '',
			cpfcnpj: '',
            isTermsConditionAccepted: true
        }
    },
    computed: {
        validateForm() {

            return !this.errors.any() && 
                this.name != '' && 
                this.username != '' && 
                this.email != '' && 
                this.password != '' && 
				this.datanascimento != '' && 
                this.cep != '' && 
				this.pin != '' && 
				this.cpfcnpj != '' && 
                this.isTermsConditionAccepted === true;
        }
    },
    methods: {
		verifica_cpf_cnpj ( valor ) {

			// Garante que o valor é uma string
			valor = valor.toString();
			
			// Remove caracteres inválidos do valor
			valor = valor.replace(/[^0-9]/g, '');

			// Verifica CPF
			if ( valor.length === 11 ) {
				return 'CPF';
			} 
			
			// Verifica CNPJ
			else if ( valor.length === 14 ) {
				return 'CNPJ';
			} 
			
			// Não retorna nada
			else {
				return false;
			}
			
		},


		calc_digitos_posicoes( digitos, posicoes = 10, soma_digitos = 0 ) {


			digitos = digitos.toString();

			for ( var i = 0; i < digitos.length; i++  ) {
				// Preenche a soma com o dígito vezes a posição
				soma_digitos = soma_digitos + ( digitos[i] * posicoes );

				// Subtrai 1 da posição
				posicoes--;

				// Parte específica para CNPJ
				// Ex.: 5-4-3-2-9-8-7-6-5-4-3-2
				if ( posicoes < 2 ) {
					// Retorno a posição para 9
					posicoes = 9;
				}
			}


			soma_digitos = soma_digitos % 11;

			// Verifica se soma_digitos é menor que 2
			if ( soma_digitos < 2 ) {
				// soma_digitos agora será zero
				soma_digitos = 0;
			} else {

				soma_digitos = 11 - soma_digitos;
			}

			var cpf = digitos + soma_digitos;

			// Retorna
			return cpf;
			
		},


		valida_cpf( valor ) {

			// Garante que o valor é uma string
			valor = valor.toString();
			
			// Remove caracteres inválidos do valor
			valor = valor.replace(/[^0-9]/g, '');


			// Captura os 9 primeiros dígitos do CPF
			// Ex.: 02546288423 = 025462884
			var digitos = valor.substr(0, 9);

			// Faz o cálculo dos 9 primeiros dígitos do CPF para obter o primeiro dígito
			var novo_cpf = this.calc_digitos_posicoes( digitos );

			// Faz o cálculo dos 10 dígitos do CPF para obter o último dígito
			var novo_cpf = this.calc_digitos_posicoes( novo_cpf, 11 );

			// Verifica se o novo CPF gerado é idêntico ao CPF enviado
			if ( novo_cpf === valor ) {
				// CPF válido
				return true;
			} else {
				// CPF inválido
				return false;
			}
			
		},


		valida_cnpj ( valor ) {

			// Garante que o valor é uma string
			valor = valor.toString();
			
			// Remove caracteres inválidos do valor
			valor = valor.replace(/[^0-9]/g, '');

			
			// O valor original
			var cnpj_original = valor;

			// Captura os primeiros 12 números do CNPJ
			var primeiros_numeros_cnpj = valor.substr( 0, 12 );

			// Faz o primeiro cálculo
			var primeiro_calculo = this.calc_digitos_posicoes( primeiros_numeros_cnpj, 5 );

			// O segundo cálculo é a mesma coisa do primeiro, porém, começa na posição 6
			var segundo_calculo = this.calc_digitos_posicoes( primeiro_calculo, 6 );

			// Concatena o segundo dígito ao CNPJ
			var cnpj = segundo_calculo;

			// Verifica se o CNPJ gerado é idêntico ao enviado
			if ( cnpj === cnpj_original ) {
				return true;
			}
			
			// Retorna falso por padrão
			return false;
			
		},

		valida_cpf_cnpj ( valor ) {

			// Verifica se é CPF ou CNPJ
			var valida = this.verifica_cpf_cnpj( valor );

			// Garante que o valor é uma string
			valor = valor.toString();
			
			// Remove caracteres inválidos do valor
			valor = valor.replace(/[^0-9]/g, '');


			// Valida CPF
			if ( valida === 'CPF' ) {
				// Retorna true para cpf válido
				return this.valida_cpf( valor );
			} 
			
			// Valida CNPJ
			else if ( valida === 'CNPJ' ) {
				// Retorna true para CNPJ válido
				return this.valida_cnpj( valor );
			} 
			
			// Não retorna nada
			else {
				return false;
			}
			
		},


        registerUser() {
			if ( this.valida_cpf_cnpj(this.cpfcnpj) == false) {
				return this.$vs.notify({
                        title: 'Error',
                        text: "CPF/CNPJ inválido!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                });
			}
            if (!this.validateForm) return false
            if(this.$store.state.auth.isUserLoggedIn()) {
              this.notifyAlreadyLogedIn();
              return
            }
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Cadastro', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "email="+this.email+"&cpfcnpj="+this.cpfcnpj+"&data_nascimento="+this.datanascimento+"&cep="+this.cep+"&pin="+this.pin+"&login="+this.username+"&nome="+this.name+"&password="+this.password
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				if(dados.success == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'UzePay',
							text: 'Conta criada com sucesso!',
							iconPack: 'feather',
							icon: 'icon-check',
							color: 'success'
						});
						const loginPayload = {
							userDetails: {
								email: this.username,
								password: this.password
							},
							notify: this.$vs.notify
						}
						const store = this.$store;
						store.dispatch('auth/login', loginPayload);
					}, 4000);

				}
				else
				{	
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'UzePay',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}
				
			})
			.catch((error) => {
			
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'UzePay',
							text: "Verifique a sua conexão.",
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
			});
            
        },
        notifyAlreadyLogedIn() {
            this.$vs.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        },
    }
}
</script>
